module.exports = __webpack_public_path__ + "img/user.2212ac16.svg";